const choices = {
    '01': 'Conjoint ou concubin notaire',
    '02': 'Partenaire pacsé',
    '03': 'Ascendants descendants alliés',
    '04': 'Benef.effecti avec PPE',
    '05': 'Liens affaires avec PPE',
};

export default choices;
